import debounce from "lodash.debounce";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { Box, Grid, Stack, Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import Title from "../../../common/Title";
import TmobilejOrderInfoList from "./OrderInfoList";

import useAxios from "../../../../hooks/useAxios";
import useAlert from "../../../../hooks/useAlert";
import { CLIENTS } from "../../../../constants/value";
import { __getOrderInfo } from "../../../../api/sim";
import { copyData } from "../../../../utils/copy";

const TmobilejOrderInfoBatch = () => {
  const { batch_id } = useParams();
  const nav = useNavigate();
  const { setAlertMessage } = useAlert();

  const [data, setData] = useState([]);
  const [metaData, setMetaData] = useState({
    page: 1,
    page_size: 20000,
    total: 1,
  });

  const COPY_KEYS = [
    "id",
    "status",
    "order_id",
    "order_status",
    "order_type",
    "order_status_message",
    "order_date",
    "created_at",
    "last_updated",
  ];

  const [response, call, loading] = useAxios({ ...__getOrderInfo });

  const fetchData = debounce(() => {
    call({
      params: {
        client: CLIENTS.tmobilej,
        batch_id,
        page_size: 20000,
        page: 1,
      },
    });
  }, 300);

  useEffect(() => {
    fetchData();
    return () => fetchData.cancel();
  }, [batch_id]);

  useEffect(() => {
    if (response && response.status) {
      setMetaData({
        page: response.data.page,
        page_size: response.data.page_size,
        total: response.data.total,
      });
      setData(response.data.data);
    }
  }, [response]);

  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        content={`Order Info Batch ID: ${batch_id}`}
        gutterBottom
      />

      {response && (
        <Grid container justifyContent="flex-start" spacing={2} mb={2}>
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button
                variant="contained"
                color="secondary"
                disabled={loading}
                onClick={() => {
                  copyData(data, COPY_KEYS);
                  setAlertMessage({
                    type: "success",
                    message: "Copied order info rows",
                  });
                }}
              >
                <ContentCopyIcon sx={{ mr: "5px" }} /> Copy Data
              </Button>
            </Stack>
          </Grid>
        </Grid>
      )}

      {response ? (
        <TmobilejOrderInfoList
          data={data}
          loading={loading}
          meta={{...metaData, page_size: 100}}
          client={true}
          handleRowClick={(params) =>
            nav(`/tmobilej/order_info/${params.row.id}`)
          }
          handleColumnClick={(key) => copyData(data, [key])}
        />
      ) : (
        <Title content="Please wait..." variant="subtitle2" gutterBottom />
      )}
    </Box>
  );
};

export default TmobilejOrderInfoBatch;
